import { ReactNode, useEffect, createContext, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import i18n, { supportedLanguages } from '../i18n';
import { authAtom } from '../atoms';

type LanguageContextType = {
  language: string;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const auth = useAtomValue(authAtom);

  useEffect(() => {
    const userLang = auth?.user?.language;
    const browserLang = navigator.language?.split('-')[0];

    let lang = 'en';

    if (userLang && supportedLanguages.includes(userLang)) {
      lang = userLang;
    } else if (supportedLanguages.includes(browserLang)) {
      lang = browserLang;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [auth]);

  const value = useMemo(() => ({ language: i18n.language }), []);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
